/* @flow */

import React, { type Node } from 'react';
import styled from 'styled-components';
import { Root } from '../TilesObjects/styles';
import brokenImageThumb from '../../../public/images/errors/broken-image-480.png';
import type { TVideo } from '../../types/helpful';
import { playMiniIcon } from '../Icons';

const Button = styled.button`
	margin: 0;
	padding: 0;
	box-shadow: none;
	border: none;
	cursor: pointer;
`;

const VideoPreview = styled.figure`
	aspect-ratio: 16 / 9;
	position: relative;
	margin: 0;
	padding: 0;
	width: 100%;
	background-color: ${({ theme }) => theme.lightGrayColor};
	overflow: hidden;

	img {
		position: absolute;
		z-index: 1;
		top: 50%;
		left: 50%;
		width: 100%;
		min-height: 100%;
		object-fit: cover;
		object-position: center;
		transform: translate(-50%, -50%);
	}

	& > svg {
		position: absolute;
		z-index: 3;
		width: 22px;
		height: 24px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		fill: ${({ theme }) => theme.toxicLimeColor};
	}

	&:before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: linear-gradient(transparent, #1e1e1e);
		opacity: 0.3;
		transition: opacity 0.3s;
		z-index: 2;
	}

	&:hover {
		&::before {
			opacity: 0;
		}
	}
`;

type TProps = {
	data: TVideo[],
	handleOpenPopup: () => {},
};

const TilesVideo = ({ data, handleOpenPopup }: TProps): Node => (
	<Root>
		{data?.map((item) => (
			<Button key={item.id.toString()} type="button" onClick={handleOpenPopup(item.youtubeCode)}>
				<VideoPreview lazy $type={item.tileType || 'normal'}>
					<img
						src={`https://img.youtube.com/vi/${item.youtubeCode}/0.jpg`}
						alt={item.title}
						onError={(e) => {
							e.target.onerror = null;
							e.target.src = brokenImageThumb;
						}}
					/>
					<svg viewBox="0 0 22 24">{playMiniIcon}</svg>
				</VideoPreview>
			</Button>
		))}
	</Root>
);

export default TilesVideo;
